import { addIcons, setAssetPath } from 'ionicons';
import * as icons from 'ionicons/icons';

/**
 * Registers Ionicons for Ionic 9+ custom-elements build.
 * Must run before bootstrap so named ion-icon / viva-input icons resolve.
 */
export function configureIonicons(): void {
  setAssetPath(document.baseURI);
  addIcons(icons);
}
